const welcome = {
    title: 'Welcome to Admin Console',
    description: 'Admin console is a web app to manage Logto without coding requirements. Let’s first create an account. With this account, you can manage Logto by yourself or on behalf of your company.',
    create_account: 'Create account',
};
export default welcome;
